import { ApiClient } from '../ApiClient.js';

export class ActivitiesApiService {
    static async list({ page = 1, per_page = 50, deal_id = null, client_id = null, entity_type = null, entity_id = null, sort_order = 'desc', activity_type = null, is_internal = null } = {}) {
        const params = { page, per_page };
        if (deal_id) params.deal_id = deal_id;
        if (client_id) params.client_id = client_id;
        if (entity_type) params.entity_type = entity_type;
        if (entity_id) params.entity_id = entity_id;
        if (sort_order) params.sort_order = sort_order;
        if (activity_type) params.activity_type = activity_type;
        if (is_internal !== null && is_internal !== undefined) params.is_internal = is_internal;
        return ApiClient.get('/api/v1/activities', params);
    }

    static async getForEntity(
        entityType,
        entityId,
        {
            page = 1,
            per_page,
            perPage,
            sort_order,
            sortOrder,
            source = null,
            is_internal,
            isInternal,
            activity_type,
        } = {},
    ) {
        const params = {
            page,
            per_page: per_page ?? perPage ?? 50,
            sort_order: sort_order ?? sortOrder ?? 'desc',
        };
        if (source) params.source = source;
        if (is_internal !== undefined) params.is_internal = is_internal;
        else if (isInternal !== undefined) params.is_internal = isInternal;
        if (activity_type) params.activity_type = activity_type;
        return ApiClient.get(`/api/v1/activities/entity/${encodeURIComponent(entityType)}/${encodeURIComponent(entityId)}`, params);
    }

    static async getAllForEntity(entityType, entityId, { sort_order, sortOrder, source = null, is_internal, isInternal } = {}) {
        // Fetch all pages without pagination limit
        const allItems = [];
        let page = 1;
        const per_page = 100;
        while (true) {
            const rows = await this.getForEntity(entityType, entityId, {
                page,
                per_page,
                sort_order: sort_order ?? sortOrder ?? 'desc',
                source,
                is_internal: is_internal ?? isInternal,
            });
            const list = Array.isArray(rows) ? rows : (rows?.data ?? []);
            if (!list.length) break;
            allItems.push(...list);
            if (list.length < per_page) break;
            page += 1;
        }
        return allItems;
    }

    static async create(payload) {
        return ApiClient.post('/api/v1/activities', payload);
    }

    static async update(activityId, payload) {
        return ApiClient.patch(`/api/v1/activities/${encodeURIComponent(activityId)}`, payload);
    }

    static async remove(activityId) {
        return ApiClient.delete(`/api/v1/activities/${encodeURIComponent(activityId)}`);
    }
}
